import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  itemDatesAside: {
    minWidth: '15.5rem',
    display: 'flex',
    gap: '1rem',
  },
  label: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: neutral['60'],
  },
  date: {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.25rem',
    color: neutral['100'],
  },
});
